import React from 'react'
import useCart from 'services/cart/hooks/use-cart'
import { useWillPipe } from '@morningtrain/react-helpers'

export default function ClearCartOnPipe (props) {
  const cart = useCart()

  useWillPipe(payload => {
    cart.clear()

    return payload
  }, [cart])

  return null
}
